<template>
	<div>
		<label class="control-label" v-if="label" :for="name">{{ label }}</label>
		<select v-model="model" :name="name" :id="name" class="form-control" :required="required">
			<slot></slot>
            <option v-for="state in states"
                    :key="`state-${state.abbreviation}`"
                    :value="state.abbreviation"
            >
                {{ state.name }}
            </option>
		</select>
	</div>
</template>

<script>
	// import States from '../../utility/states';
    import states from '../../utility/state_list.json';
	
	export default {
		props: {
			label: {
				type: String,
				default: () => ''
			},
			name: {
				type: String,
				default: () => 'state'
			},
            required: {
			    type: Boolean,
                default: false
            },
			value: {
				type: String,
				default: () => ''
			},
			atts: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				states: states,
				model: ''
			}
		},

        created () {
            this.model = this.value;
        },

		watch: {
			model(model) {
				this.$emit('input', model);
			},
			value(value) {
				this.model = value;
			}
		}
	}
</script>